import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { merge, noop } from 'lodash';
import {
    ContentZonesService,
    ConfigsService as GeneralConfigService,
    LocaleService,
    UrlService,
    WindowProxy,
} from '@sm360/widget-commons-core-services';
import { HistoryService, Translations as GeneralTranslations } from '@sm360/widget-commons-general';
import { Translations as FormTranslations } from '@sm360/widget-commons-forms';
import config from 'trade-in/config/index.js';

import TradeInWrapper from 'trade-in/components/TradeInWrapper/TradeInWrapper.jsx';

import en from 'trade-in/i18n/en.json';
import fr from 'trade-in/i18n/fr.json';

const czGroup = 'widget.tradein';
class TradeInProvider extends Component {
    constructor(props) {
        super(props);

        merge(en, FormTranslations.en, GeneralTranslations.en);
        merge(fr, FormTranslations.fr, GeneralTranslations.fr);

        LocaleService.setLocale(props.locale);
        LocaleService.loadTranslations({ en, fr });

        GeneralConfigService.setWebsiteId(props.websiteId);
        GeneralConfigService.setOrganizationId(this.props.organizationId);
        GeneralConfigService.setOrganizationUnitId(this.props.organizationUnitId);
        GeneralConfigService.setOrganizationUnitLocation(this.props.organizationUnitLocation);

        this.onUnload = this.onUnload.bind(this);

        ContentZonesService.setImageServerBaseUrl(config.source.image);
        ContentZonesService.addContentZones(this.props.contentZones);
    }

    componentDidMount() {
        const $window = WindowProxy.get();
        if ($window) {
            $window.addEventListener('beforeunload', this.onUnload);
        }
    }

    componentWillUnmount() {
        this.onUnload();
    }

    onUnload() {
        HistoryService.add(WindowProxy.location().href);
    }

    render() {
        const cz = ContentZonesService.getContentZone(czGroup, 'hascbb');
        const hasCBB = cz ? cz.getValue() === 'true' : false;
        const isOfficialTradeIn = hasCBB ? ['official', 'officiel'].includes(UrlService.getUrlParameter('view')) : true;

        return (
            <TradeInWrapper
                useCBB={hasCBB}
                isOfficialTradeIn={isOfficialTradeIn}
                isRenderedInModal={false}
                onTradeInSuccess={this.props.onTradeInSuccess}
            />
        );
    }
}

TradeInProvider.displayName = 'TradeInProvider';

TradeInProvider.defaultProps = {
    onTradeInSuccess: noop,
};

TradeInProvider.propTypes = {
    locale: PropTypes.string.isRequired,
    websiteId: PropTypes.number.isRequired,
    organizationUnitId: PropTypes.number.isRequired,
    organizationId: PropTypes.number.isRequired,
    organizationUnitLocation: PropTypes.string.isRequired,
    onTradeInSuccess: PropTypes.func,
    contentZones: PropTypes.objectOf(
        PropTypes.arrayOf(
            PropTypes.shape({
                active: PropTypes.bool,
                group: PropTypes.string,
                id: PropTypes.number,
                location: PropTypes.string,
                position: PropTypes.number,
                type: PropTypes.string,
                value: PropTypes.string,
            })
        )
    ).isRequired,
};

export default TradeInProvider;



// WEBPACK FOOTER //
// ./src/TradeInProvider.jsx